var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"heading":"404 Item Not Found"}},[_c('p',[_vm._v("It looks like you're lost.")]),_c('p',[_vm._v("Go back "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("home")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }